/* eslint-disable prettier/prettier */
import { useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { FileService } from '../../services/file.service';
import Switch from 'react-switch';
import { GeneralInfoComparisonSection } from '../../components/comparison/GeneralInfoComparisonSection';
import { BrokersComparisonSection } from '../../components/comparison/BrokersComparisonSection';
import { SignaturesComparisonSection } from '../../components/comparison/SignatureComparisonSection';
import { CedantsComparisonSection } from '../../components/comparison/CedantsComparisonSection';
import { ProportionalSectionsComparison } from '../../components/comparison/ProportionalSectionsComparison';

export const ComparePVDetailsPage = () => {
  const [searchParams] = useSearchParams();
  const leftVersion = searchParams.get('left');
  const rightVersion = searchParams.get('right');

  const [ComparisonData, setComparisonData] = useState<any>({});

  const [leftPdf, setLeftPdf] = useState<string | undefined>(undefined);
  const [rightPdf, setRightPdf] = useState<string | undefined>(undefined);

  const [showDifferences, setShowDifferences] = useState(false);

  useEffect(() => {
    if (leftVersion && rightVersion) {
      const fetchComparisonData = async () => {
        try {
          const response = await FileService.compareVersions(leftVersion, rightVersion);

          setComparisonData(response.data);

          if (response.data.files && response.data.files.id) {
            const leftPdfResponse = await FileService.getPdfByFileId(response.data.files.id.left);
            const rightPdfResponse = await FileService.getPdfByFileId(response.data.files.id.right);

            setLeftPdf(URL.createObjectURL(leftPdfResponse.data));
            setRightPdf(URL.createObjectURL(rightPdfResponse.data));
          } else {
            console.error('Files or file ids are missing in the response');
          }
        } catch (error) {
          console.error('Error comparing treaties:', error);
        }
      };

      fetchComparisonData();
    }
  }, [leftVersion, rightVersion]);

  const toggleDifferences = (checked: boolean) => {
    setShowDifferences(checked);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-6 sm:flex-row">
        <div className="w-full sm:w-1/2">
          <h2 className="mb-2 text-xl font-semibold text-center text-primary sm:text-left">
            {ComparisonData.files?.name?.left || 'Left Version'}
          </h2>
          {leftPdf && <embed src={leftPdf} type="application/pdf" width="95%" height="400px" />}
        </div>

        <div className="w-full sm:w-1/2">
          <h2 className="mb-2 text-xl font-semibold text-center text-primary sm:text-left">
            {ComparisonData.files?.name?.right || 'Right Version'}
          </h2>
          {rightPdf && <embed src={rightPdf} type="application/pdf" width="95%" height="400px" />}
        </div>
      </div>

      <div className="flex justify-start mt-3">
        <label className="flex items-center">
          <span className="mr-3 ">
            <Switch
              className="mt-[6px]"
              onChange={toggleDifferences}
              checked={showDifferences}
              offColor="#B6CCD7"
              onColor="#2C6F91"
              uncheckedIcon={false}
              checkedIcon={false}
              height={21}
              width={50}
            />
          </span>
          Show differences only
        </label>
      </div>

      <div className="flex flex-col mt-3 width-[95%]">
        <GeneralInfoComparisonSection
          generalInfo={ComparisonData.generalInfo}
          showDifferences={showDifferences}
        />
        <CedantsComparisonSection
          cedants={ComparisonData.cedants}
          showDifferences={showDifferences}
        />
        <BrokersComparisonSection
          brokers={ComparisonData.brokers}
          showDifferences={showDifferences}
        />
        <SignaturesComparisonSection
          signatures={ComparisonData.signatures}
          showDifferences={showDifferences}
        />
        <ProportionalSectionsComparison
          sections={ComparisonData.ProportionalSections}
          showDifferences={showDifferences}
        />
      </div>
    </div>
  );
};
